export default "__VITE_ASSET__fe9ba0c2__"